(function () {
  let observer = null;
  let loading = false;
  let currentNextPageUrl = null;

  const loadedUrls = new Set();
  const loadedProductUrls = new Set();

  function getProductGrid() {
    return document.querySelector('#product-grid');
  }

  function getProductGridContainer() {
    return document.querySelector('#ProductGridContainer');
  }

  function getPaginationWrapper(container) {
    return container?.querySelector('.pagination-wrapper') || null;
  }

  function getNextPageUrl(paginationWrapper) {
    if (!paginationWrapper) return null;

    const nextLink =
      paginationWrapper.querySelector('a[rel="next"]') ||
      paginationWrapper.querySelector(
        '.pagination__item--prev[href*="page="]'
      );

    return nextLink ? nextLink.href : null;
  }

  function registerExistingProducts(productGrid) {
    loadedProductUrls.clear();

    productGrid
      .querySelectorAll('li')
      .forEach((item) => {
        const productLink =
          item.querySelector('a.full-unstyled-link[href]') ||
          item.querySelector('a[href*="/products/"]');

        if (productLink) {
          loadedProductUrls.add(
            new URL(productLink.href, window.location.origin).pathname
          );
        }
      });
  }

  function removeOldSentinel() {
    document.querySelector('#infinite-scroll-sentinel')?.remove();
  }

  function createSentinel(productGridContainer) {
    removeOldSentinel();

    const sentinel = document.createElement('div');
    sentinel.id = 'infinite-scroll-sentinel';
    sentinel.setAttribute('aria-hidden', 'true');

    sentinel.innerHTML = `
      <div class="madamas-infinite-spinner"></div>
    `;

    productGridContainer.insertAdjacentElement('afterend', sentinel);

    return sentinel;
  }

  async function loadNextPage(
    productGrid,
    paginationWrapper,
    sentinel
  ) {
    if (
      loading ||
      !currentNextPageUrl ||
      loadedUrls.has(currentNextPageUrl)
    ) {
      return;
    }

    loading = true;

    const urlToLoad = currentNextPageUrl;

    loadedUrls.add(urlToLoad);
    sentinel.classList.add('is-loading');

    try {
      const response = await fetch(urlToLoad, {
        method: 'GET',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin'
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const html = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newGrid = doc.querySelector('#product-grid');

      const newPagination = doc.querySelector(
        '#ProductGridContainer .pagination-wrapper'
      );

      if (!newGrid) {
        throw new Error('Nieuwe productgrid niet gevonden.');
      }

      const newItems = Array.from(
        newGrid.querySelectorAll(':scope > li')
      );

      const fragment = document.createDocumentFragment();

      newItems.forEach((item) => {
        const productLink =
          item.querySelector('a.full-unstyled-link[href]') ||
          item.querySelector('a[href*="/products/"]');

        if (!productLink) {
          return;
        }

        const productPath = new URL(
          productLink.href,
          window.location.origin
        ).pathname;

        /*
         * Heel belangrijk:
         * nooit dezelfde productkaart twee keer toevoegen.
         */
        if (loadedProductUrls.has(productPath)) {
          return;
        }

        loadedProductUrls.add(productPath);

        item.classList.add(
          'madamas-infinite-item',
          'is-visible'
        );

        fragment.appendChild(item);
      });

      /*
       * Alle nieuwe producten in één bewerking toevoegen.
       * Dit voorkomt DOM-races op mobiel.
       */
      productGrid.appendChild(fragment);

      /*
       * Daarna pas bepalen wat de volgende pagina is.
       */
      currentNextPageUrl = getNextPageUrl(newPagination);

      if (!currentNextPageUrl) {
        observer?.disconnect();
        observer = null;
        sentinel.remove();
      }

    } catch (error) {
      console.error(
        'Madamas infinite scroll fout:',
        error
      );

      /*
       * Als laden mislukt:
       * standaard Shopify-pagination terug tonen.
       */
      paginationWrapper.style.display = '';

      observer?.disconnect();
      observer = null;

      sentinel.remove();

    } finally {
      loading = false;

      if (document.body.contains(sentinel)) {
        sentinel.classList.remove('is-loading');
      }
    }
  }

  function initInfiniteScroll() {
    const productGrid = getProductGrid();
    const productGridContainer = getProductGridContainer();

    if (!productGrid || !productGridContainer) {
      return;
    }

    if (observer) {
      observer.disconnect();
      observer = null;
    }

    removeOldSentinel();

    /*
     * Bij filteren/sorteren beginnen we opnieuw
     * met de producten die momenteel écht in de grid staan.
     */
    registerExistingProducts(productGrid);

    loadedUrls.clear();

    const paginationWrapper =
      getPaginationWrapper(productGridContainer);

    if (!paginationWrapper) {
      return;
    }

    currentNextPageUrl =
      getNextPageUrl(paginationWrapper);

    if (!currentNextPageUrl) {
      return;
    }

    /*
     * Shopify-pagination blijft technisch aanwezig,
     * maar wordt verborgen wanneer infinite scroll werkt.
     */
    paginationWrapper.style.display = 'none';

    const sentinel =
      createSentinel(productGridContainer);

    observer = new IntersectionObserver(
      (entries) => {
        const visible = entries.some(
          (entry) => entry.isIntersecting
        );

        if (!visible) {
          return;
        }

        loadNextPage(
          productGrid,
          paginationWrapper,
          sentinel
        );
      },
      {
        root: null,

        /*
         * Ook mobiel mag vooraf laden,
         * maar iets minder agressief dan voordien.
         */
        rootMargin: '0px 0px 300px 0px',

        threshold: 0
      }
    );

    observer.observe(sentinel);
  }

  function addStyles() {
    if (
      document.querySelector(
        '#madamas-infinite-scroll-styles'
      )
    ) {
      return;
    }

    const style = document.createElement('style');

    style.id =
      'madamas-infinite-scroll-styles';

    style.textContent = `
      #infinite-scroll-sentinel {
        min-height: 72px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
      }

      .madamas-infinite-spinner {
        width: 26px;
        height: 26px;
        border: 2px solid rgba(54, 68, 60, 0.15);
        border-top-color: #36443c;
        border-radius: 50%;
        animation: madamas-infinite-spin 0.8s linear infinite;
        opacity: 0;
        transition: opacity 0.2s ease;
      }

      #infinite-scroll-sentinel.is-loading
      .madamas-infinite-spinner {
        opacity: 1;
      }

      .madamas-infinite-item {
        opacity: 1;
      }

      @keyframes madamas-infinite-spin {
        to {
          transform: rotate(360deg);
        }
      }
    `;

    document.head.appendChild(style);
  }

  function boot() {
    addStyles();
    initInfiniteScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      boot
    );
  } else {
    boot();
  }

  /*
   * Dawn vervangt ProductGridContainer
   * bij filteren of sorteren.
   */
  const pageObserver = new MutationObserver(
    (mutations) => {
      const gridChanged = mutations.some(
        (mutation) => {
          return Array.from(
            mutation.addedNodes
          ).some((node) => {
            return (
              node.nodeType === 1 &&
              (
                node.id ===
                  'ProductGridContainer' ||
                node.querySelector?.(
                  '#ProductGridContainer'
                )
              )
            );
          });
        }
      );

      if (gridChanged) {
        window.setTimeout(
          initInfiniteScroll,
          150
        );
      }
    }
  );

  pageObserver.observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );
})();